<template>
    <o-form :title="$t('sandoz.master_product')" class="ortic-form-horizontal" ref="form"
            :url="'/api/sandoz/product_masters/' + $route.params.id + '?include=products,product_master_sales_lines.sales_line,product_master_prices.sales_line_price_category.sales_line,sub_products.sub_product_master.products,product_master_values'" @loaded="loaded">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-input :errorField="'product_master_id'" :label="$t('sandoz.identifier')"
                             v-model="props.item.product_master_id"/>
                    <b-alert show>{{$t('sandoz.product_year_hint')}}</b-alert>
                    <o-input :label="$t('sandoz.year')" v-model="props.item.year" :type="'number'" mask="####"></o-input>
                    <o-value-select :items="statuses" :label="$t('sandoz.status')" v-model="props.item.status"/>
                    <o-value-select :items="types" :label="$t('sandoz.type')" v-model="props.item.type"/>
                    <o-value-select :errorField="'delivery'" :items="deliveries" :label="$t('sandoz.delivery')" v-model="props.item.delivery"/>
                    <o-value-select :items="deliveryModes" :label="$t('sandoz.delivery_mode')" v-model="props.item.delivery_mode"/>
                    <o-input type="number" :errorField="'delivery_time'" :label="$t('sandoz.delivery_time')"
                             v-model="props.item.delivery_time" :placeholder="$t('sandoz.delivery_time_hint')"/>
                    <o-input :errorField="'distributor'" :label="$t('sandoz.distributor')"
                             v-model="props.item.distributor"/>
                    <o-input :errorField="'supplier'" :label="$t('sandoz.supplier')"
                             v-model="props.item.supplier"/>
                    <o-input :errorField="'product_group'" :label="$t('sandoz.product_group')"
                             v-model="props.item.product_group"/>
                    <o-value-select :items="productCategories" :label="$t('sandoz.product_category')" v-model="props.item.product_category"/>
                    <b-alert show>{{$t('sandoz.needs_verification_hint')}}</b-alert>
                    <o-checkbox :errorField="'needs_verification'" :label="$t('sandoz.needs_verification')"
                                v-model="props.item.needs_verification"/>
                    <o-value-select :items="vRequirements" :label="$t('sandoz.verification_requirement')"
                                    v-model="props.item.verification_requirement"/>
                    <b-alert show>{{$t('sandoz.big_item_split_hint')}}</b-alert>
                    <o-checkbox :errorField="'big_item_split'" :label="$t('sandoz.big_item_split')" v-model="props.item.big_item_split"/>
                    <o-file-upload :label="$t('sandoz.picture')" v-model="props.item.picture" :allow-clear="true"
                                   :allow-download="true" accept="image/*">
                    </o-file-upload>
                    <o-input :errorField="'item_height'" :label="$t('sandoz.item_height')"
                             v-model="props.item.item_height"/>
                    <o-input :errorField="'item_depth'" :label="$t('sandoz.item_depth')"
                             v-model="props.item.item_depth"/>
                    <o-input :errorField="'item_width'" :label="$t('sandoz.item_width')"
                             v-model="props.item.item_width"/>
                    <o-input :errorField="'max_items'" :label="$t('sandoz.max_items')"
                             v-model="props.item.max_items" type="number"/>
                    <o-input :errorField="'max_adhoc_items'" :label="$t('sandoz.max_adhoc_items')"
                           v-model="props.item.max_adhoc_items" type="number"/>
                    <o-value-select :items="importStatuses" :label="$t('sandoz.import_status')" v-model="props.item.import_status"/>
                    <hr>
                    <o-form-group :label="$t('sandoz.apo_one')">
                        <div class="w-100">
                          <label class="w-100">{{$t('sandoz.allow_quantity_for_the_month')}}</label>
                          <b-form-checkbox v-model="props.item.apo_one" value="jan" >{{$t('sandoz.january')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="feb">{{$t('sandoz.february')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="mar">{{$t('sandoz.march')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="apr">{{$t('sandoz.april')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="may">{{$t('sandoz.may')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="jun">{{$t('sandoz.june')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="jul">{{$t('sandoz.july')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="aug">{{$t('sandoz.august')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="sep">{{$t('sandoz.september')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="oct">{{$t('sandoz.october')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="nov">{{$t('sandoz.november')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.apo_one" value="dec">{{$t('sandoz.december')}}</b-form-checkbox>
                        </div>
                    </o-form-group>
                </b-col>
                <b-col>
                    <o-checkbox :errorField="'show_quantity'" :label="$t('sandoz.show_quantity')"
                              v-model="props.item.show_quantity"/>

                    <o-checkbox :errorField="'sandoz_academy_event'" :label="$t('sandoz.sandoz_academy_event')" v-model="props.item.sandoz_academy_event"/>
                    <o-checkbox :errorField="'show_quantity_in_contract'" :label="$t('sandoz.show_quantity_in_contract')" v-model="props.item.show_quantity_in_contract"/>
                    <o-checkbox :errorField="'sandoz_ownership'" :label="$t('sandoz.sandoz_ownership')" v-model="props.item.sandoz_ownership"/>
                    <o-checkbox :errorField="'hide_in_contract'" :label="$t('sandoz.hide_in_contract')" v-model="props.item.hide_in_contract"/>
                    <o-checkbox :errorField="'show_on_top_on_invoice'" :label="$t('sandoz.show_on_top_on_invoice')" v-model="props.item.show_on_top_on_invoice"/>

                    <o-checkbox :errorField="'allow_product_name_to_change'" :label="$t('sandoz.allow_product_name_to_change')" v-model="props.item.allow_product_name_to_change"/>
                    <o-checkbox :errorField="'allow_manual_date_entry'" :label="$t('sandoz.allow_manual_date_entry')" v-model="props.item.allow_manual_date_entry"/>
                    <o-checkbox :errorField="'allow_date_to_set_children'" :label="$t('sandoz.allow_date_to_set_children')" v-model="props.item.allow_date_to_set_children"/>
                    <o-checkbox :errorField="'sync_quater_with_children'" :label="$t('sandoz.sync_quater_with_children')" v-model="props.item.sync_quater_with_children"/>
                    <o-input :errorField="'sort_order'" :label="$t('sandoz.sort_order')" v-model="props.item.sort_order" :min="1" :step="1"/>
                    <o-input :errorField="'max_quantity'" :label="$t('sandoz.max_quantity')" v-model="props.item.max_quantity" type="number"/>
                    <o-value-select :items="boxOrGadget" :label="$t('sandoz.box_or_gadget')" v-model="props.item.box_or_gadget"/>
                    <o-checkbox :errorField="'digitial_screen_category'" :label="$t('sandoz.digitial_screen_category')" v-model="props.item.digitial_screen_category"/>

                    <o-value-select :url="'/api/sandoz/product_masters'" :label="$t('sandoz.price_parent')" v-model="props.item.price_parent_id" :value-field="'id'" :text-field="'product_master_id'"/>
                    <o-checkbox :errorField="'hold_actual_amount_of_educational'" :label="$t('sandoz.hold_actual_amount_of_educational')" v-model="props.item.hold_actual_amount_of_educational"/>
                    <o-checkbox :errorField="'hide_invoice_duration'" :label="$t('sandoz.hide_invoice_duration')" v-model="props.item.hide_invoice_duration"/>
                    <o-checkbox :errorField="'required_in_bios_apo_item'" :label="$t('sandoz.required_in_bios_apo_item')"
                              v-model="props.item.required_in_bios_apo_item"/>
                    <o-checkbox :errorField="'adhoc_delivery_per_quarter'" :label="$t('sandoz.adhoc_delivery_per_quarter')"
                              v-model="props.item.adhoc_delivery_per_quarter"/>
                    <o-checkbox :errorField="'apo_otc_sortalys_product'" :label="$t('sandoz.apo_otc_sortalys_product')"
                              v-model="props.item.apo_otc_sortalys_product"/>
                    <o-checkbox :errorField="'disabled'" :label="$t('sandoz.disabled')"
                              v-model="props.item.disabled"/>
                </b-col>
            </b-row>
        </template>
        <template slot="child" slot-scope="props">
            <b-tabs>
                <b-tab :title="$t('sandoz.products')" active>
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.product_id')}}</th>
                                    <th>{{$t('sandoz.name')}}</th>
                                    <th>{{$t('sandoz.short_name')}}</th>
                                    <th>{{$t('sandoz.info')}}</th>
                                    <th>{{$t('sandoz.info_link')}}</th>
                                    <th class="text-right">
                                        <b-btn v-if="props.item.product_master_id" @click.prevent="setProduct()"
                                               variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(product, i) in props.item.products">
                                    <td>{{product.product_id}}
                                      <span class="badge badge-warning" v-if="mismatchProducts.includes(product.id)">
                                        {{$t('sandoz.mismatch')}}
                                      </span>
                                    </td>
                                    <td>{{product.name}}</td>
                                    <td>{{product.short_name}}</td>
                                    <td>{{product.info}}</td>
                                    <td>{{product.info_link}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="setProduct(i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.lines')">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.line_id')}}</th>
                                    <th>{{$t('sandoz.name')}}</th>
                                    <th>{{$t('sandoz.price_changes')}}</th>
                                    <th>{{$t('sandoz.exist_value')}}</th>
                                    <th>{{$t('sandoz.exists_attribute_required')}}</th>
                                    <th>{{$t('sandoz.user_date_yearly_input')}}</th>
                                    <th>{{$t('sandoz.user_date_q1_input')}}</th>
                                    <th>{{$t('sandoz.user_date_q2_input')}}</th>
                                    <th>{{$t('sandoz.user_date_q3_input')}}</th>
                                    <th>{{$t('sandoz.user_date_q4_input')}}</th>
                                    <th>{{$t('sandoz.transfer_monthly_quantity_to_quarter')}}</th>
                                    <th>{{$t('sandoz.apo_one_multiply_with_quantity')}}</th>
                                    <th>{{$t('sandoz.visibility')}}</th>
                                    <th>{{$t('sandoz.invoicing_allowed')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="setLine()" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(line, i) in props.item.product_master_sales_lines">
                                    <td>{{line.sales_line_id}}</td>
                                    <td>{{line.sales_line ? line.sales_line.sales_line : '' }}</td>
                                    <td>{{line.price_changes ? $t('sandoz.' + line.price_changes) : '' }}</td>
                                    <td>{{line.exist_value ? $t('sandoz.' + line.exist_value) : '' }}</td>
                                    <td>
                                        <template v-if="line.exists_attribute_required">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.user_date_yearly_input">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.user_date_q1_input">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.user_date_q2_input">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="line.user_date_q3_input">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.user_date_q4_input">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.transfer_monthly_quantity_to_quarter">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td>
                                        <template v-if="line.apo_one_multiply_with_quantity">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>
                                    <td>{{line.item_visibility ? $t('sandoz.'+line.item_visibility): ''}}</td>

                                    <td>
                                        <template v-if="line.invoicing_allowed">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>

                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.product_master_sales_lines.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="setLine(i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.price')">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.price_category')}}</th>
                                    <th>{{$t('sandoz.price')}}</th>
                                    <th>{{$t('sandoz.adjustable_price')}}</th>
                                    <th>{{$t('sandoz.fixed_independent_fte')}}</th>
                                    <th class="text-right">
                                        <b-btn v-if="props.item.product_master_id" @click.prevent="setPrice()"
                                               variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(price, i) in props.item.product_master_prices">
                                    <td>
                                      {{price.sales_line_price_category ? price.sales_line_price_category.price_category: ''}}
                                      {{price.sales_line_price_category && price.sales_line_price_category.sales_line ? '(' + price.sales_line_price_category.sales_line.sales_line + ')': ''}}
                                    </td>
                                    <td>{{price.price}}</td>
                                    <td>{{price.adjustable_price ? $t('sandoz.' + price.adjustable_price): ''}}</td>
                                    <td>
                                        <template v-if="price.fixed_independent_fte">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.product_master_prices.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="setPrice(i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.sub_products')">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.identifier')}}</th>
                                    <th>{{$t('sandoz.year')}}</th>
                                    <th>{{$t('sandoz.product_group')}}</th>
                                    <th>{{$t('sandoz.products')}}</th>
                                    <th>{{$t('sandoz.write_qty_to_parent')}}</th>
                                    <th>{{$t('sandoz.child_qty')}}</th>
                                    <th>{{$t('sandoz.sort_order')}}</th>
                                    <th class="text-right">
                                        <b-btn v-if="props.item.product_master_id" @click.prevent="setSubProduct()"
                                               variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(product, i) in props.item.sub_products">
                                    <td>{{ product.sub_product_master ? product.sub_product_master.product_master_id : '' }}</td>
                                    <td>{{ product.sub_product_master && product.sub_product_master.year ? product.sub_product_master.year : '*' }}</td>
                                    <td>{{ product.sub_product_master ? product.sub_product_master.product_group : '' }}</td>
                                    <td>
                                        <template v-for="(p, index) in product.sub_product_master.products">
                                            <span class="badge badge-info">{{p.language}}</span>
                                            {{p.name}}
                                            <br v-if="product.sub_product_master.products.length > index + 1"/>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="product.write_qty_from_child_to_parent">
                                            <fa icon="check"/>
                                        </template>
                                        <template v-else>
                                            <fa icon="times"/>
                                        </template>
                                    </td>
                                    <td>{{ product.child_qty ? product.child_qty : '-' }}</td>
                                    <td>{{ product.sub_product_master ? product.sub_product_master.sort_order : '' }}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.sub_products.splice(i, 1)"
                                                   variant="secondary">
                                              <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="setSubProduct(i)" variant="primary">
                                              <fa icon="pencil-alt"/>
                                            </b-btn>
                                            <b-btn variant="secondary" @click.prevent="gotoProduct(product.sub_product_master_id)">
                                              <fa icon="arrow-right"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.fixed_values')">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.value')}}</th>
                                    <th class="text-right">
                                        <b-btn v-if="props.item.product_master_id" @click.prevent="setFixValue()"
                                               variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(value, i) in props.item.product_master_values">
                                    <td>{{value.value}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.product_master_values.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="setFixValue(i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
            </b-tabs>
            <b-modal id="modal-add-product" ref="addProduct" :title="$t('sandoz.add_product')" @ok="addProduct()">
                <o-form-group :label="$t('sandoz.product_id')" v-if="$refs.form">
                    <div class="w-100 text-muted">{{ (language ? language.toUpperCase() : '') + '-' + $refs.form.item.product_master_id }}</div>
                </o-form-group>
                <o-form-group :label="$t('sandoz.language')">
                    <b-form-select v-model="language" :options="languages" value-field="value" text-field="text"></b-form-select>
                </o-form-group>
                <o-input :label="$t('sandoz.name')" v-model="name"></o-input>
                <o-input :label="$t('sandoz.short_name')" v-model="short_name"></o-input>
                <o-textarea :label="$t('core.description')" v-model="description"></o-textarea>
                <o-textarea :label="$t('sandoz.info')" v-model="info"></o-textarea>
                <o-textarea :label="$t('sandoz.info_link')" v-model="infoLink"></o-textarea>
            </b-modal>
            <b-modal id="modal-add-line" ref="addLine" :title="$t('sandoz.add_line')" @ok="addLine()">
                <o-value-select ref="salesLineSelector" :url="'/api/sandoz/sales_lines'" :label="$t('sandoz.name')"
                                v-model="sales_line_id" :value-field="'id'" :text-field="'sales_line'"/>
                <o-value-select ref="priceChangesSelector" :items="manualPriceChanges" :label="$t('sandoz.price_changes')"
                                v-model="priceChanges"/>

                <o-value-select :items="existOptions" :label="$t('sandoz.exist_value')" v-model="exist_value"/>
                <o-checkbox :errorField="'exists_attribute_required'" :label="$t('sandoz.exists_attribute_required')"
                                v-model="exists_attribute_required" :readonly="checkReadonly(exist_value)"/>
                <o-checkbox :errorField="'user_date_yearly_input'" :label="$t('sandoz.user_date_yearly_input')" v-model="user_date_yearly_input"/>
                <o-checkbox :errorField="'user_date_q1_input'" :label="$t('sandoz.user_date_q1_input')" v-model="user_date_q1_input"/>
                <o-checkbox :errorField="'user_date_q2_input'" :label="$t('sandoz.user_date_q2_input')" v-model="user_date_q2_input"/>
                <o-checkbox :errorField="'user_date_q3_input'" :label="$t('sandoz.user_date_q3_input')" v-model="user_date_q3_input"/>
                <o-checkbox :errorField="'user_date_q4_input'" :label="$t('sandoz.user_date_q4_input')" v-model="user_date_q4_input"/>
                <o-checkbox :errorField="'transfer_monthly_quantity_to_quarter'" :label="$t('sandoz.transfer_monthly_quantity_to_quarter')" v-model="transfer_monthly_quantity_to_quarter"/>
                <o-checkbox :errorField="'apo_one_multiply_with_quantity'" v-if="transfer_monthly_quantity_to_quarter" :label="$t('sandoz.apo_one_multiply_with_quantity')" v-model="apoOneMultiplyWithQuantity"/>
                <o-value-select :items="itemVisibilityOptions" :label="$t('sandoz.visibility')" v-model="itemVisibility"/>
                <o-checkbox :errorField="'invoicing_allowed'" :label="$t('sandoz.invoicing_allowed')" v-model="invoicing_allowed"/>
            </b-modal>
            <b-modal id="modal-add-price" ref="addPrice" :title="$t('sandoz.add_price')" @ok="addPrice()">
                <o-value-select ref="priceCategorySelector" :url="'/api/sandoz/product_masters/sales_price_category/' + props.item.id"
                                :label="$t('sandoz.price_category')" v-model="price_category_id"
                                :value-field="'id'" :text-field="'price_category_line'"/>
                <o-input :label="$t('sandoz.price')" v-model="price" :type="'number'"></o-input>
                <o-value-select :items="adjPriceOptions" :label="$t('sandoz.adjustable_price')" v-model="adjustable_price"/>
                <o-checkbox :label="$t('sandoz.fixed_independent_fte')" v-model="fixed_independent_fte"/>
            </b-modal>
            <b-modal id="modal-add-sub-product" ref="addSubProduct" :title="$t('sandoz.add_product')" @ok="addSubProduct()">
                <o-form-group :label="$t('sandoz.master_identifier')" v-if="$refs.form">
                    <div class="w-100 text-muted">{{ $refs.form.item.product_master_id }}</div>
                </o-form-group>
                <o-value-select-search ref="productMasterSelector" :url="'/api/sandoz/product_masters'" :label="$t('sandoz.identifier')"
                              v-model="sub_product_master_id" :value-field="'id'" :text-field="'id_year_product'" @input-object="setSubProductYear"/>
                <o-checkbox :errorField="'write_qty_from_child_to_parent'" :label="$t('sandoz.write_qty_to_parent')" v-model="writeQtyToParent"/>
                <o-input :errorField="'child_qty'" :label="$t('sandoz.child_qty')" v-model="childQty" type="number"/>

                <o-form-group :label="$t('sandoz.year')" v-if="sub_product_master_id">
                    <div class="w-100 text-muted">{{ sub_product_year === null ? '*' : sub_product_year}}</div>
                </o-form-group>
                <o-checkbox :errorField="'yearly_quantity'" :label="$t('sandoz.yearly_quantity')" v-model="yearlyQty"/>
                <o-checkbox :errorField="'q1_quantity'" :label="$t('sandoz.q1_quantity')" v-model="q1Qty"/>
                <o-checkbox :errorField="'q2_quantity'" :label="$t('sandoz.q2_quantity')" v-model="q2Qty"/>
                <o-checkbox :errorField="'q3_quantity'" :label="$t('sandoz.q3_quantity')" v-model="q3Qty"/>
                <o-checkbox :errorField="'q4_quantity'" :label="$t('sandoz.q4_quantity')" v-model="q4Qty"/>
            </b-modal>
            <b-modal id="modal-add-fix-value" ref="addFixvalue" :title="$t('sandoz.add_fix_value')" @ok="addFixvalue()">
                <o-input :label="$t('sandoz.value')" v-model="value" :type="'number'"></o-input>
            </b-modal>
        </template>
        <template slot="footer-warning">
          <span class="text-danger mr-3" v-if="mismatchProducts && mismatchProducts.length > 0">
            {{ $t('sandoz.product_id_mismatch') }}
          </span>
        </template>
    </o-form>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      types: [],
      importStatuses: [],
      name: null,
      language: null,
      product_id: null,
      i: null,
      short_name: null,
      deliveries: [],
      deliveryModes: [],
      sales_line_id: null,
      price_category_id: null,
      price: null,
      languages: [],
      description: null,
      vRequirements: null,
      statuses: [],
      sub_product_master_id: null,
      sub_product_master: {},
      info: null,
      infoLink: null,
      writeQtyToParent: null,
      childQty: null,
      manualPriceChanges: [],
      priceChanges: null,
      boxOrGadget: [],
      productCategories: [],
      existOptions: [],
      adjPriceOptions: [],
      adjustable_price: 'yes',
      fixed_independent_fte: false,
      pItems: [],
      yearlyQty: null,
      q1Qty: null,
      q2Qty: null,
      q3Qty: null,
      q4Qty: null,
      exist_value:null,
      exists_attribute_required:false,
      user_date_yearly_input:null,
      user_date_q1_input:null,
      user_date_q2_input:null,
      user_date_q3_input:null,
      user_date_q4_input:null,
      transfer_monthly_quantity_to_quarter:null,
      apoOneMultiplyWithQuantity: false,
      value: null,
      itemVisibilityOptions: [],
      itemVisibility: 'both',
      sub_product_year: null,
      mismatchProducts: [],
      invoicing_allowed: false
    }),
    created() {
      this.languages = [
        {value: 'de', text: 'DE'},
        {value: 'en', text: 'EN'},
        {value: 'fr', text: 'FR'},
        {value: 'it', text: 'IT'}
      ]
      this.types = [
        {value: 'service', text: this.$i18n.t('sandoz.service')},
        {value: 'marketing_activity', text: this.$i18n.t('sandoz.marketing_activity')}
      ]
      this.deliveries = [
        {value: 'yearly', text: this.$i18n.t('sandoz.yearly')},
        {value: 'quarter', text: this.$i18n.t('sandoz.quarter')}
      ]
      this.deliveryModes = [
        {value: 'always', text: this.$i18n.t('sandoz.always')},
        {value: 'never', text: this.$i18n.t('sandoz.never')},
        {value: 'once_per_contract', text: this.$i18n.t('sandoz.once_per_contract')}
      ]
      this.vRequirements = [
        {value: 'with_every_delivery', text: this.$i18n.t('sandoz.with_every_delivery')},
        {value: 'once_a_year', text: this.$i18n.t('sandoz.once_a_year')}
      ]
      this.statuses = [
        {value: 'active', text: this.$i18n.t('sandoz.active')},
        {value: 'legacy', text: this.$i18n.t('sandoz.legacy')},
        {value: 'inactive', text: this.$i18n.t('sandoz.inactive')}
      ]
      this.importStatuses = [
        {value: null, text: this.$i18n.t('sandoz.import_status_undefined')},
        {value: 'a', text: this.$i18n.t('sandoz.import_status_gadget')},
        {value: 'n', text: this.$i18n.t('sandoz.import_status_no_delivery')},
        {value: 'h', text: this.$i18n.t('sandoz.import_status_set_header')},
        {value: 'w', text: this.$i18n.t('sandoz.import_status_set_item')}
      ]
      this.manualPriceChanges = [
        {value: 'no_changes_allowed', text: this.$i18n.t('sandoz.no_changes_allowed')},
        {value: 'changes_allowed', text: this.$i18n.t('sandoz.changes_allowed')},
        {value: 'minus_20_allowed', text: this.$i18n.t('sandoz.minus_20_allowed')},
        {value: 'any_price_allowed', text: this.$i18n.t('sandoz.any_price_allowed')}
      ]
      this.boxOrGadget = [
        {value: null, text: this.$i18n.t('sandoz.select')},
        {value: 'set', text: this.$i18n.t('sandoz.set')},
        {value: 'box', text: this.$i18n.t('sandoz.box')},
        {value: 'gadget', text: this.$i18n.t('sandoz.gadget')},
      ]
      this.productCategories = [
        {value: null, text: this.$i18n.t('sandoz.select')},
        {value: 'OTC', text: 'OTC'},
        {value: 'Brand', text: 'Brand'},
      ]
      this.existOptions = [
        {value: null, text: this.$i18n.t('sandoz.select')},
        {value: 'yes', text: this.$i18n.t('sandoz.yes')},
        {value: 'no', text: this.$i18n.t('sandoz.no')},
      ]
      this.adjPriceOptions = [
        {value: 'yes', text: this.$i18n.t('sandoz.yes')},
        {value: 'no', text: this.$i18n.t('sandoz.no')},
      ]
      this.itemVisibilityOptions = [
        {value: 'both', text: this.$i18n.t('sandoz.both')},
        {value: 'item', text: this.$i18n.t('sandoz.item')},
        {value: 'adhoc_item', text: this.$i18n.t('sandoz.adhoc_item')}
      ]
    },
    methods: {
      setSubProduct (i = null) {
        this.i = i
        this.resetSubProduct()
        if (this.i !== null) {
          this.product_master_id = this.$refs.form.item.id
          this.sub_product_master_id = this.$refs.form.item.sub_products[this.i].sub_product_master_id
          this.sub_product_master = this.$refs.form.item.sub_products[this.i].sub_product_master
          this.writeQtyToParent = this.$refs.form.item.sub_products[this.i].write_qty_from_child_to_parent
          this.childQty = this.$refs.form.item.sub_products[this.i].child_qty
          this.yearlyQty = this.$refs.form.item.sub_products[this.i].yearly_quantity
          this.q1Qty = this.$refs.form.item.sub_products[this.i].q1_quantity
          this.q2Qty = this.$refs.form.item.sub_products[this.i].q2_quantity
          this.q3Qty = this.$refs.form.item.sub_products[this.i].q3_quantity
          this.q4Qty = this.$refs.form.item.sub_products[this.i].q4_quantity
        }
        this.$refs.addSubProduct.show()
      },
      addSubProduct () {
        this.resetSubProduct()
        const selectedOption = this.$refs.productMasterSelector.$el.querySelector('input.localvalue').value
        if (this.i !== null) {
          this.$refs.form.item.sub_products[this.i].product_master_id = this.$refs.form.item.id
          this.$refs.form.item.sub_products[this.i].sub_product_master_id = selectedOption ? selectedOption : null
          this.$refs.form.item.sub_products[this.i].sub_product_master = {
            product_master_id: selectedOption ? this.$refs.productMasterSelector.displayName : null
          }
          this.$refs.form.item.sub_products[this.i].write_qty_from_child_to_parent = this.writeQtyToParent
          this.$refs.form.item.sub_products[this.i].child_qty = this.childQty
          this.$refs.form.item.sub_products[this.i].yearly_quantity = this.yearlyQty
          this.$refs.form.item.sub_products[this.i].q1_quantity = this.q1Qty
          this.$refs.form.item.sub_products[this.i].q2_quantity = this.q2Qty
          this.$refs.form.item.sub_products[this.i].q3_quantity = this.q3Qty
          this.$refs.form.item.sub_products[this.i].q4_quantity = this.q4Qty

        } else {
          if (this.$refs.form.item.sub_products === undefined) {
            this.$refs.form.item.sub_products = [{
              product_master_id: this.$refs.form.item.id,
              sub_product_master_id: selectedOption ? selectedOption : null,
              sub_product_master: {
                product_master_id: selectedOption ? this.$refs.productMasterSelector.displayName : null
              },
              write_qty_from_child_to_parent: this.writeQtyToParent,
              child_qty: this.childQty,
              yearly_quantity: this.yearlyQty,
              q1_quantity: this.q1Qty,
              q2_quantity: this.q2Qty,
              q3_quantity: this.q3Qty,
              q4_quantity: this.q4Qty,
              created_at: new Date()
            }]
          } else {
            this.$refs.form.item.sub_products.unshift({
              product_master_id: this.$refs.form.item.id,
              sub_product_master_id: selectedOption ? selectedOption : null,
              sub_product_master: {
                product_master_id: selectedOption ? this.$refs.productMasterSelector.displayName : null
              },
              write_qty_from_child_to_parent: this.writeQtyToParent,
              child_qty: this.childQty,
              yearly_quantity: this.yearlyQty,
              q1_quantity: this.q1Qty,
              q2_quantity: this.q2Qty,
              q3_quantity: this.q3Qty,
              q4_quantity: this.q4Qty,
              created_at: new Date()
            })
          }
        }
        this.resetSubProduct()
        this.$refs.addSubProduct.hide()
      },
      resetSubProduct () {
        this.language = this.user.language
        this.product_master_id = this.$refs.form.item.id
        this.sub_product_master_id = null
        this.write_qty_from_child_to_parent = null
        this.child_qty = null
        this.sub_product_master = {}
        this.yearly_quantity = null,
        this.q1_quantity = null,
        this.q2_quantity = null,
        this.q3_quantity = null,
        this.q4_quantity = null
      },
      setProduct(i = null) {
        this.i = i
        this.reset()
        if(this.i !== null) {
          this.name = this.$refs.form.item.products[this.i].name
          this.language = this.$refs.form.item.products[this.i].language
          this.product_id = this.$refs.form.item.products[this.i].product_id
          this.short_name = this.$refs.form.item.products[this.i].short_name
          this.description = this.$refs.form.item.products[this.i].description
          this.info = this.$refs.form.item.products[this.i].info
          this.infoLink = this.$refs.form.item.products[this.i].info_link
        }
        this.$refs.addProduct.show()
      },
      addProduct() {
        if(this.i !== null) {
          this.$refs.form.item.products[this.i].name = this.name
          this.$refs.form.item.products[this.i].language = this.language
          this.$refs.form.item.products[this.i].product_id = (this.language ? this.language.toUpperCase() : '') + '-' + this.$refs.form.item.product_master_id
          this.$refs.form.item.products[this.i].short_name = this.short_name
          this.$refs.form.item.products[this.i].description = this.description
          this.$refs.form.item.products[this.i].info = this.info
          this.$refs.form.item.products[this.i].info_link = this.infoLink
        } else {
          if(this.name && this.name.trim()) {
            if(this.$refs.form.item.products === undefined) {
              this.$refs.form.item.products = [{
                name: this.name,
                language: this.language,
                product_id: (this.language ? this.language.toUpperCase() : '') + '-' + this.$refs.form.item.product_master_id,
                short_name: this.short_name,
                description: this.description,
                info: this.info,
                info_link: this.infoLink,
                created_at: new Date()
              }]
            } else {
              this.$refs.form.item.products.unshift({
                name: this.name,
                language: this.language,
                product_id: (this.language ? this.language.toUpperCase() : '') + '-' + this.$refs.form.item.product_master_id,
                short_name: this.short_name,
                description: this.description,
                info: this.info,
                info_link: this.infoLink,
                created_at: new Date()
              })
            }
          }
        }

        this.reset()
        this.$refs.addProduct.hide()
      },
      reset() {
        this.name = null
        this.language = this.user.language
        this.product_id = this.language.toUpperCase() + '-' + this.$refs.form.item.product_master_id
        this.short_name = null
        this.description = null
        this.info = null
        this.infoLink = null
        this.verifyProducts()
      },
      setLine(i = null) {
        this.i = i
        this.sales_line_id = null
        this.priceChanges = null
        this.exist_value = null
        this.exists_attribute_required = false
        this.user_date_yearly_input = null
        this.user_date_q1_input = null
        this.user_date_q2_input = null
        this.user_date_q3_input = null
        this.user_date_q4_input = null
        this.transfer_monthly_quantity_to_quarter = null
        this.apoOneMultiplyWithQuantity = false
        this.itemVisibility = 'both'
        this.invoicing_allowed = false

        if (this.i !== null) {
          this.sales_line_id = this.$refs.form.item.product_master_sales_lines[this.i].sales_line_id
          this.year = this.$refs.form.item.product_master_sales_lines[this.i].year
          this.priceChanges = this.$refs.form.item.product_master_sales_lines[this.i].price_changes
          this.exist_value = this.$refs.form.item.product_master_sales_lines[this.i].exist_value
          this.exists_attribute_required = this.$refs.form.item.product_master_sales_lines[this.i].exists_attribute_required
          this.user_date_yearly_input = this.$refs.form.item.product_master_sales_lines[this.i].user_date_yearly_input
          this.user_date_q1_input = this.$refs.form.item.product_master_sales_lines[this.i].user_date_q1_input
          this.user_date_q2_input = this.$refs.form.item.product_master_sales_lines[this.i].user_date_q2_input
          this.user_date_q3_input = this.$refs.form.item.product_master_sales_lines[this.i].user_date_q3_input
          this.user_date_q4_input = this.$refs.form.item.product_master_sales_lines[this.i].user_date_q4_input
          this.transfer_monthly_quantity_to_quarter = this.$refs.form.item.product_master_sales_lines[this.i].transfer_monthly_quantity_to_quarter
          this.apoOneMultiplyWithQuantity = this.$refs.form.item.product_master_sales_lines[this.i].apo_one_multiply_with_quantity
          this.itemVisibility = this.$refs.form.item.product_master_sales_lines[this.i].item_visibility
          this.invoicing_allowed = this.$refs.form.item.product_master_sales_lines[this.i].invoicing_allowed
        }
        this.$refs.addLine.show()
      },
      addLine() {
        let options = this.$refs.salesLineSelector.$el.querySelector('select').options
        if(this.i !== null) {
          this.$refs.form.item.product_master_sales_lines[this.i].sales_line_id  = this.sales_line_id
          this.$refs.form.item.product_master_sales_lines[this.i].product_master_id  = this.$refs.form.item.id
          this.$refs.form.item.product_master_sales_lines[this.i].price_changes  = this.priceChanges

          this.$refs.form.item.product_master_sales_lines[this.i].exist_value = this.exist_value
          this.$refs.form.item.product_master_sales_lines[this.i].exists_attribute_required = this.exists_attribute_required
          this.$refs.form.item.product_master_sales_lines[this.i].user_date_yearly_input = this.user_date_yearly_input
          this.$refs.form.item.product_master_sales_lines[this.i].user_date_q1_input = this.user_date_q1_input
          this.$refs.form.item.product_master_sales_lines[this.i].user_date_q2_input = this.user_date_q2_input
          this.$refs.form.item.product_master_sales_lines[this.i].user_date_q3_input = this.user_date_q3_input
          this.$refs.form.item.product_master_sales_lines[this.i].user_date_q4_input = this.user_date_q4_input
          this.$refs.form.item.product_master_sales_lines[this.i].transfer_monthly_quantity_to_quarter = this.transfer_monthly_quantity_to_quarter
          this.$refs.form.item.product_master_sales_lines[this.i].apo_one_multiply_with_quantity = this.apoOneMultiplyWithQuantity
          this.$refs.form.item.product_master_sales_lines[this.i].item_visibility = this.itemVisibility
          this.$refs.form.item.product_master_sales_lines[this.i].invoicing_allowed = this.invoicing_allowed

          this.$refs.form.item.product_master_sales_lines[this.i].sales_line = {
            sales_line: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
          }
        } else {
          if(this.sales_line_id) {
            if(this.$refs.form.item.product_master_sales_lines === undefined) {
              this.$refs.form.item.product_master_sales_lines = [{
                product_master_id: this.$refs.form.item.id,
                sales_line_id: this.sales_line_id,
                price_changes: this.priceChanges,
                exist_value :this.exist_value,
                exists_attribute_required :this.exists_attribute_required,
                user_date_yearly_input :this.user_date_yearly_input,
                user_date_q1_input :this.user_date_q1_input,
                user_date_q2_input :this.user_date_q2_input,
                user_date_q3_input :this.user_date_q3_input,
                user_date_q4_input :this.user_date_q4_input,
                transfer_monthly_quantity_to_quarter: this.transfer_monthly_quantity_to_quarter,
                apo_one_multiply_with_quantity: this.apoOneMultiplyWithQuantity,
                item_visibility: this.itemVisibility,
                invoicing_allowed: this.invoicing_allowed,
                created_at: new Date(),
                sales_line: {
                  sales_line: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
                }
               }]
              } else {
                this.$refs.form.item.product_master_sales_lines.unshift({
                  product_master_id: this.$refs.form.item.id,
                  sales_line_id: this.sales_line_id,
                  price_changes: this.priceChanges,
                  exist_value :this.exist_value,
                  exists_attribute_required :this.exists_attribute_required,
                  user_date_yearly_input :this.user_date_yearly_input,
                  user_date_q1_input :this.user_date_q1_input,
                  user_date_q2_input :this.user_date_q2_input,
                  user_date_q3_input :this.user_date_q3_input,
                  user_date_q4_input :this.user_date_q4_input,
                  transfer_monthly_quantity_to_quarter: this.transfer_monthly_quantity_to_quarter,
                  apo_one_multiply_with_quantity: this.apoOneMultiplyWithQuantity,
                  item_visibility: this.itemVisibility,
                  invoicing_allowed: this.invoicing_allowed,
                  created_at: new Date(),
                  sales_line: {
                    sales_line: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
                  }
                })
              }
          }
        }

        this.sales_line_id = null
        this.priceChanges = null
        this.exist_value = null
        this.exists_attribute_required = false
        this.user_date_yearly_input = null
        this.user_date_q1_input = null
        this.user_date_q2_input = null
        this.user_date_q3_input = null
        this.user_date_q4_input = null
        this.transfer_monthly_quantity_to_quarter = null
        this.apoOneMultiplyWithQuantity = false
        this.itemVisibility = 'both'
        this.invoicing_allowed = false
        this.$refs.addLine.hide()
      },
      setPrice(i = null) {
        this.i = i
        this.price_category_id = null
        this.price = null
        this.adjustable_price = 'yes'
        this.fixed_independent_fte = false
        if(this.i !== null) {
          this.price = this.$refs.form.item.product_master_prices[this.i].price
          this.price_category_id = this.$refs.form.item.product_master_prices[this.i].price_category_id
          this.adjustable_price = this.$refs.form.item.product_master_prices[this.i].adjustable_price
          this.fixed_independent_fte = this.$refs.form.item.product_master_prices[this.i].fixed_independent_fte
        }
        this.$refs.addPrice.show()
      },
      addPrice() {
        let options = this.$refs.priceCategorySelector.$el.querySelector('select').options
        if(this.i !== null) {
          this.$refs.form.item.product_master_prices[this.i].price_category_id = this.price_category_id
          this.$refs.form.item.product_master_prices[this.i].product_master_id = this.$refs.form.item.id
          this.$refs.form.item.product_master_prices[this.i].price = this.price
          this.$refs.form.item.product_master_prices[this.i].sales_line_price_category = {
            price_category: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
          }
          this.$refs.form.item.product_master_prices[this.i].adjustable_price = this.adjustable_price
          this.$refs.form.item.product_master_prices[this.i].fixed_independent_fte = this.fixed_independent_fte

        } else {
          if(this.price_category_id) {
            if(this.$refs.form.item.product_master_prices === undefined) {
              this.$refs.form.item.product_master_prices = [{
                product_master_id: this.$refs.form.item.id,
                price_category_id: this.price_category_id,
                price: this.price,
                created_at: new Date(),
                sales_line_price_category: {
                  price_category: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
                },
                adjustable_price: this.adjustable_price,
                fixed_independent_fte: this.fixed_independent_fte
              }]
            } else {
              this.$refs.form.item.product_master_prices.unshift({
                product_master_id: this.$refs.form.item.id,
                price_category_id: this.price_category_id,
                price: this.price,
                created_at: new Date(),
                sales_line_price_category: {
                  price_category: options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''
                },
                adjustable_price: this.adjustable_price,
                fixed_independent_fte: this.fixed_independent_fte,
              })
            }
          }
        }

        this.price_category_id = null
        this.price = null
        this.adjustable_price = null
        this.fixed_independent_fte = null
        this.$refs.addPrice.hide()
      },
      gotoProduct (id) {
        const route = this.$router.resolve({ path: '/sandoz/product_masters/' + id })
        window.open(route.href)
      },
      loaded(item) {
        this.verifyProducts()
        if(item.sub_products) {
          return item.sub_products.sort((a, b) => a.sort_order - b.sort_order)
        }
      },
      checkReadonly(exist_value) {
        if(exist_value === 'yes' || exist_value === 'no'){
          return true
        }
        return false
      },
      setFixValue(i = null) {
        this.i = i
        this.value = null
        if(this.i !== null) {
          this.value = this.$refs.form.item.product_master_values[this.i].value
        }
        this.$refs.addFixvalue.show()
      },
      addFixvalue() {
        if(this.i !== null) {
          this.$refs.form.item.product_master_values[this.i].product_master_id = this.$refs.form.item.id
          this.$refs.form.item.product_master_values[this.i].value = this.value
        } else {
          if(this.value) {
            if(this.$refs.form.item.product_master_values === undefined) {
              this.$refs.form.item.product_master_values = [{
                product_master_id: this.$refs.form.item.id,
                value: this.value
              }]
            } else {
              this.$refs.form.item.product_master_values.unshift({
                product_master_id: this.$refs.form.item.id,
                value: this.value
              })
            }
          }
        }

        this.value = null
        this.$refs.addFixvalue.hide()
      },
      setSubProductYear(product) {
        if(product) {
          this.sub_product_year = product.year
        }
      },
      verifyProducts() {
        const self = this;
        self.mismatchProducts = []
        if(self.$refs.form.item && self.$refs.form.item.products) {
          self.$refs.form.item.products.forEach(function (product){
            if(product.product_id.replace(/EN-|DE-|FR-|IT-/, '') != self.$refs.form.item.product_master_id) {
              self.mismatchProducts.push(product.id)
            }
          })
        }
      }
    },
    computed: mapGetters({
      user: 'auth/user'
    }),
    watch: {
      transfer_monthly_quantity_to_quarter : function (newVal, oldVal) {
        if(!newVal && oldVal) {
          this.apoOneMultiplyWithQuantity = false
        }
      }
    }
  }
</script>
